module.exports = __webpack_public_path__ + "img/ico_calendar_black.ed1e00dc.svg";